import userReducer from "./slices/userSlice";
import settingReducer from "./slices/settingSlice";
import dashboardReducer from "./slices/dashboardSlice";
import sidebarReducer from "./slices/sidebarSlice";
import permissionReducer from "./slices/permissionSlice";

const rootReducer = {
    userReducer,
    settingReducer,
    permissionReducer,
    dashboardReducer,
    sidebarReducer,
};

export default rootReducer;
